import EventCollagesModal, { EVENT_COLLAGES_MODAL } from './modal';

export { EVENT_COLLAGES_MODAL };
export default EventCollagesModal;
